import React from 'react';
import styled from 'styled-components';

/*

Props:

• flexDirection
• alignItems
• flexDirection_mediaQ1
• otherSyles
• otherSyles_mediaQ1

*/

const StyledDiv = styled.div`

    display: flex;
    align-items: ${props => (props.alignItems) ? props.alignItems : 'flex-start'};
    flex-direction:${props => (props.flexDirection) ? props.flexDirection : 'column'};
    ${props => (props.otherSyles) ? props.otherSyles : ''}

    @media (max-width: ${props => (props.mediaQ1) ? props.mediaQ1 : '0'}px){
        flex-direction: ${props => (props.flexDirection_mediaQ1) ? props.flexDirection_mediaQ1 : 'column'};
        ${props => (props.otherSyles_mediaQ1) ? props.otherSyles_mediaQ1 : ''}
    } 
`;

const StyledFlexDirection = ({ styles, children, ...rest }) => (
    <StyledDiv style = {styles} {...rest}>
        { children }
    </StyledDiv>
  )
  

export default StyledFlexDirection;


// WEBPACK FOOTER //
// ./src/js/components/StyledFlexDirection.jsx